import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { faqs } from "../lib/data";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="relative py-28 px-6 lg:px-8 bg-[#070B1A]">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="section-label">FAQ</span>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tighter mt-5">
            Questions, <span className="gradient-text">answered</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`glass rounded-2xl overflow-hidden transition-all ${
                  isOpen ? "border-blue-500/30" : ""
                }`}
                data-testid={`faq-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-6 text-left"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="font-bold text-lg">{f.q}</span>
                  <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                    isOpen ? "bg-blue-600" : "bg-white/5"
                  }`}>
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </div>
                </button>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div className="px-6 pb-6 text-slate-400 leading-relaxed">{f.a}</div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
